import { createAction } from 'redux-actions';
export const SET_SELECTED_PASSENGER_ID = 'SET_SELECTED_PASSENGER_ID';
export const setSelectedPassengerId = createAction(SET_SELECTED_PASSENGER_ID);
